// import queryString from "query-string";
import React, { useContext, useState } from "react";
import {
  CustomButton2,
  CustomDropdownFilter,
  CustomDropdownMultiSearch,
  CustomDropdownSearch,
  CustomTimePiker,
  CustomView,
  //   CustomRadioButtonGroup,
  //   DropDownSearchCities,
  //   DropDownSearchProvinces,
  //   DropDownSearchSuperAgent,
} from "../../../../components";
import Cookies from "js-cookie";
import constants from "../../../../values/constants";
import "./index.scss";
import { useQuery } from "react-query";
import values from "../../../../values";
import api from "../../../../api";
import Context from "../../../../context";
import {
  ICityItem,
  ICompanyItem,
  IItem,
  IOnSearchUser,
  IProvinceItem,
} from "../../../../types/common.interface";
import utils from "../../../../utils";
import { IUpdateStudent } from "../../../../types/student.interface";
import CustomCalender from "../../../../components/Custom.DatePicker/CustomCalender";
import { useTranslation } from "react-i18next";

const FilterAgent = () => {
  // ============================== Value Validation ================================

  //   const {search} = queryString.parse(window.location.search);
  const [effect, setEffect] = React.useState(false);
  const [selectedFilters, setSelectedFilters] = React.useState<any>({
    // isBlock,
    // isApproved,
    // province,
    // city,
  });

  const { requestLog, setRequestLog } = useContext(Context.LogScreen);

  const [searchedValueStudent, setSearchedValueStudent] =
    useState<IOnSearchUser>();
  const [searchedValueCompany, setSearchedValueCompany] =
    useState<IOnSearchUser>();
  const [searchedValueDriver, setSearchedValueDriver] =
    useState<IOnSearchUser>();
  const [searchedValueSuperAgent, setSearchedValueSuperAgent] =
    useState<IOnSearchUser>();
  const [searchedValueParent, setSearchedValueParent] =
    useState<IOnSearchUser>();
  const [searchedValueSchool, setSearchedValueSchool] =
    useState<IOnSearchUser>();
  const [searchedValueAbsentType, setSearchedValueAbsentType] =
    useState<IOnSearchUser>();
  const [searchedValueStatusInService, setSearchedValueStatusInService] =
    useState<IOnSearchUser>();
  const [searchedValueIsChecked, setSearchedValueIsChecked] =
    useState<IOnSearchUser>();

  const [selectedStartDate, setSelectedStartDate] = React.useState<
    string | undefined
  >();
  const [selectedEndDate, setSelectedEndDate] = React.useState<
    string | undefined
  >();

  const userType = utils.stringHexConversion.reverse(
    Cookies.get(constants.USER.TYPE)
  );

  // ------------------------get students  ----------------------------

  const getAllStudent = useQuery(
    [values.useQueryKeys.getAllService, searchedValueStudent?.searchedValue],
    () =>
      api.post.common.findStudent({
        search: {
          base: searchedValueStudent?.base?.value?.split(".")[1],
          value: searchedValueStudent?.searchedValue,
        },
      })
  );

  const AllStudentWithCompleteName = getAllStudent?.data?.result?.docs?.map(
    (item: any) => {
      return {
        ...item,
        completeName: item.firstName + " " + item.lastName,
      };
    }
  );
  const [selectedStudent, setSelectedStudent] = useState<any>();

  // ------------------------get companies  ----------------------------

  const getAllCompanyAdmin = useQuery(
    [values.useQueryKeys.getAllCompany, searchedValueCompany?.searchedValue],
    () =>
      api.post.administrator.getAllCompany({
        search: {
          base: searchedValueCompany?.base?.value,
          value: searchedValueCompany?.searchedValue,
        },
      }),
    { enabled: userType === "ADMIN" }
  );

  const getAllCompanySuperAgent = useQuery(
    [values.useQueryKeys.getAllCompany, searchedValueCompany?.searchedValue],
    () =>
      api.post.superAgent.findCompany({
        search: {
          base: searchedValueCompany?.base?.value,
          value: searchedValueCompany?.searchedValue,
        },
      }),
    { enabled: userType !== "ADMIN" }
  );

  const getAllCompany =
    userType === "ADMIN" ? getAllCompanyAdmin : getAllCompanySuperAgent;

  const [selectedCompany, setSelectedCompany] = useState<any>();

  const companyWithCompleteName = getAllCompany?.data?.result?.map(
    (item: any) => ({
      ...item,
      completeName: item?.companyInformation?.companyName,
    })
  );

  // ------------------------get drivers  ----------------------------

  const getAllDriverByAdmin = useQuery(
    [values.useQueryKeys.getAllDriver, searchedValueDriver?.searchedValue],
    () =>
      api.post.common.findDriver({
        search: {
          base: searchedValueDriver?.base?.value,
          value: searchedValueDriver?.searchedValue,
        },
      }),
    { enabled: userType === "ADMIN" }
  );
  const getAllDriverBySuperAgent = useQuery(
    [values.useQueryKeys.getAllDriver, searchedValueDriver?.searchedValue],
    () =>
      api.post.superAgent.findDriver({
        search: {
          base: searchedValueDriver?.base?.value,
          value: searchedValueDriver?.searchedValue,
        },
      }),
    { enabled: userType === "SUPERAGENT" }
  );
  const getAllDriverByCompany = useQuery(
    [values.useQueryKeys.getAllDriver, searchedValueDriver?.searchedValue],
    () =>
      api.post.company.findDriver({
        search: {
          base: searchedValueDriver?.base?.value,
          value: searchedValueDriver?.searchedValue,
        },
      }),
    { enabled: userType === "COMPANY" }
  );

  const getAllDriver =
    userType === "ADMIN"
      ? getAllDriverByAdmin
      : userType !== "SUPERAGENT"
      ? getAllDriverBySuperAgent
      : getAllDriverByCompany;
  const [selectedDriver, setSelectedDriver] = useState<any>();

  const driverWithCompleteName = getAllDriver?.data?.result?.map(
    (item: any) => ({
      ...item,
      completeName: item?.firstName + " " + item?.lastName,
    })
  );

  // ------------------------get superAgents  ----------------------------

  const getAllSuperAgents = useQuery(
    [
      values.useQueryKeys.getAllSuperAgent,
      searchedValueSuperAgent?.searchedValue,
    ],
    () =>
      api.post.administrator.getAllSuperAgent({
        search: {
          base: searchedValueSuperAgent?.base?.value,
          value: searchedValueSuperAgent?.searchedValue,
        },
      }),
    { enabled: userType === "ADMIN" }
  );

  const [selectedSuperAgent, setSelectedSuperAgent] = useState<any>();

  const superAgentWithCompleteName = getAllSuperAgents?.data?.result?.map(
    (item: any) => ({
      ...item,
      completeName: item?.firstName + " " + item?.lastName,
    })
  );
  // ------------------------get parents  ----------------------------

  const getAllParentByAdmin = useQuery(
    [values.useQueryKeys.getAllParent, searchedValueParent?.searchedValue],
    () =>
      api.post.administrator.getAllParent({
        search: {
          base: searchedValueParent?.base?.value,
          value: searchedValueParent?.searchedValue,
        },
      }),
    { enabled: userType === "ADMIN" }
  );

  const getAllParentByCommon = useQuery(
    [values.useQueryKeys.getAllParent, searchedValueParent?.searchedValue],
    () =>
      api.post.common.findParent({
        search: {
          base: searchedValueParent?.base?.value,
          value: searchedValueParent?.searchedValue,
        },
      }),
    { enabled: userType !== "ADMIN" }
  );

  const getAllParent =
    userType === "ADMIN" ? getAllParentByAdmin : getAllParentByCommon;

  const [selectedParent, setSelectedParent] = useState<any>();

  const parentWithCompleteName = getAllParent?.data?.result?.map(
    (item: any) => ({
      ...item,
      completeName: item?.firstName + " " + item?.lastName,
    })
  );

  // ------------------------get schools  ----------------------------

  const getAllSchools = useQuery(
    [values.useQueryKeys.getAllSchool, searchedValueSchool?.searchedValue],
    () =>
      api.post.common.findSchoolPost({
        search: {
          base: searchedValueSchool?.base?.value,
          value: searchedValueSchool?.searchedValue,
        },
      })
  );

  const [selectedSchool, setSelectedSchool] = useState<any>();

  const resetFilter = () => {
    setRequestLog({
      limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
      page: 1,
    });
    setSelectedSchool(undefined);
    setSelectedCompany(undefined);
    setSelectedDriver(undefined);
    setSelectedParent(undefined);
    setSelectedSuperAgent(undefined);
    setSelectedStudent(undefined);
  };

  // ================================ UseEffect Call ===============================

  React.useEffect(() => {
    if (effect) {
      //   utils.urlGenerator({
      //     navigate,
      //     filters: selectedFilters,
      //     searchString: search ? String(search) : null,
      //   });
    } else setEffect(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilters]);

  const { t } = useTranslation();

  const parentBaseSearch =
    userType === "ADMIN"
      ? values.dropdownBaseSearch.PARENT_BASE_SEARCH
      : values.dropdownBaseSearch.PARENT_BASE_SEARCH_SUPERAGENT;
  const companyBaseSearch =
    userType === "SUPER_AGENT_SCHOOL"
      ? values.dropdownBaseSearch.COMPANY_BASE_SEARCH_SUPERAGENT_ROLE
      : values.dropdownBaseSearch.COMPANY_BASE_SEARCH;
  const driverBaseSearch =
    userType === "ADMIN"
      ? values.dropdownBaseSearch.DRIVER_BASE_SEARCH
      : values.dropdownBaseSearch.DRIVER_BASE_SEARCH_SUPERAGENT;

  // ================================== JSX Content ================================
  return (
    <div className="filter-container">
      <CustomDropdownFilter title={t("filter")}>
        <CustomView.Row>
          <CustomView.Column medium={6}>
            <label className="form-label">{t("dateFrom")}</label>
            <CustomTimePiker
              placeholder={t("startDate")}
              maxDate={new Date()}
              defaultValue={selectedStartDate}
              onChange={(event: any) => {
                setSelectedStartDate(event);
                setRequestLog({
                  ...requestLog,
                  filters: {
                    ...requestLog.filters,
                    startDate: event,
                  },
                });
              }}
            />
          </CustomView.Column>
          <CustomView.Column medium={6}>
            <label className="form-label">{t("dateTo")}</label>
            <CustomTimePiker
              placeholder={t("endDate")}
              maxDate={new Date()}
              minDate={new Date(selectedStartDate as string)}
              defaultValue={selectedEndDate}
              onChange={(event: any) => {
                setSelectedEndDate(event);
                setRequestLog({
                  ...requestLog,
                  filters: {
                    ...requestLog.filters,
                    endDate: event,
                  },
                });
              }}
            />
          </CustomView.Column>
        </CustomView.Row>
        <CustomView.Row>
          {userType === "ADMIN" && (
            <CustomView.Column medium={6}>
              <label className="form-label">{t("superAgent")}</label>
              <CustomDropdownMultiSearch
                isSearch
                baseSearch={values.dropdownBaseSearch.SUPER_AGENT_BASE_SEARCH.map(
                  (item) => ({
                    ...item,
                    title: t(item.title),
                  })
                )}
                items={superAgentWithCompleteName}
                itemName="completeName"
                onSelectItem={(event: any) => {
                  setSelectedSuperAgent(event);
                  setRequestLog({
                    ...requestLog,
                    filters: {
                      ...requestLog.filters,
                      superAgent: event,
                    },
                  });
                }}
                defaultItem={selectedSuperAgent}
                searchedValue={searchedValueSuperAgent}
                setSearchedValue={setSearchedValueSuperAgent}
                placeHolder={t("selectEducation")}
                isLoading={getAllSuperAgents.isLoading}
                selectedBaseSearch={searchedValueSuperAgent?.base?.value}
              />
            </CustomView.Column>
          )}

          <CustomView.Column medium={6}>
            <label className="form-label">{t("school")}</label>
            <CustomDropdownMultiSearch
              isSearch
              baseSearch={values.dropdownBaseSearch.SCHOOL_BASE_SEARCH.map(
                (item) => ({
                  ...item,
                  title: t(item.title),
                })
              )}
              items={getAllSchools?.data?.result}
              itemName="name"
              onSelectItem={(event: any) => {
                setSelectedSchool(event);
                setRequestLog({
                  ...requestLog,
                  filters: {
                    ...requestLog.filters,
                    school: event,
                  },
                });
              }}
              defaultItem={selectedSchool}
              searchedValue={searchedValueSchool}
              setSearchedValue={setSearchedValueSchool}
              placeHolder={t("selectSchol")}
              isLoading={getAllSchools.isLoading}
              selectedBaseSearch={searchedValueSchool?.base?.value}
            />
          </CustomView.Column>
          <CustomView.Column medium={6}>
            <label className="form-label">{t("parent")}</label>
            <CustomDropdownMultiSearch
              isSearch
              baseSearch={parentBaseSearch.map((item) => ({
                ...item,
                title: t(item.title),
              }))}
              items={parentWithCompleteName}
              itemName="completeName"
              onSelectItem={(event: any) => {
                setSelectedParent(event);
                setRequestLog({
                  ...requestLog,
                  filters: {
                    ...requestLog.filters,
                    parent: event,
                  },
                });
              }}
              defaultItem={selectedParent}
              searchedValue={searchedValueParent}
              setSearchedValue={setSearchedValueParent}
              placeHolder={t("selectParent")}
              isLoading={getAllParent.isLoading}
              selectedBaseSearch={searchedValueParent?.base?.value}
            />
          </CustomView.Column>

          <CustomView.Column medium={6}>
            <label className="form-label">{t("student")}</label>
            <CustomDropdownMultiSearch
              isSearch
              baseSearch={values.dropdownBaseSearch.SERVICE_BASE_SEARCH.map(
                (item) => ({
                  ...item,
                  title: t(item.title),
                })
              )}
              items={AllStudentWithCompleteName}
              itemName="completeName"
              onSelectItem={(event: any) => {
                setSelectedStudent(event);
                setRequestLog({
                  ...requestLog,
                  filters: {
                    ...requestLog.filters,
                    student: event,
                  },
                });
              }}
              defaultItem={selectedStudent}
              searchedValue={searchedValueStudent}
              setSearchedValue={setSearchedValueStudent}
              placeHolder={t("selectStudent")}
              isLoading={getAllStudent.isLoading}
              selectedBaseSearch={searchedValueStudent?.base?.value}
            />
          </CustomView.Column>
          {userType === "ADMIN" ||
            (userType === "SUPER_AGENT_SCHOOL" && (
              <CustomView.Column medium={6}>
                <label className="form-label">{t("company")}</label>
                <CustomDropdownMultiSearch
                  isSearch
                  baseSearch={companyBaseSearch.map((item) => ({
                    ...item,
                    title: t(item.title),
                  }))}
                  items={companyWithCompleteName}
                  itemName="completeName"
                  onSelectItem={(event: any) => {
                    setSelectedCompany(event);
                    setRequestLog({
                      ...requestLog,
                      filters: {
                        ...requestLog.filters,
                        company: event,
                      },
                    });
                  }}
                  defaultItem={selectedCompany}
                  searchedValue={searchedValueCompany}
                  setSearchedValue={setSearchedValueCompany}
                  placeHolder={t("selectCompany")}
                  isLoading={getAllCompany.isLoading}
                  selectedBaseSearch={searchedValueCompany?.base?.value}
                />
              </CustomView.Column>
            ))}

          <CustomView.Column medium={6}>
            <label className="form-label">{t("driver")}</label>
            <CustomDropdownMultiSearch
              isSearch
              baseSearch={driverBaseSearch.map((item) => ({
                ...item,
                title: t(item.title),
              }))}
              items={driverWithCompleteName}
              itemName="completeName"
              onSelectItem={(event: any) => {
                setSelectedDriver(event);
                setRequestLog({
                  ...requestLog,
                  filters: {
                    ...requestLog.filters,
                    driver: event,
                  },
                });
              }}
              defaultItem={selectedDriver}
              searchedValue={searchedValueDriver}
              setSearchedValue={setSearchedValueDriver}
              placeHolder={t("selectDriver")}
              isLoading={getAllDriver.isLoading}
              selectedBaseSearch={searchedValueDriver?.base?.value}
            />
          </CustomView.Column>
        </CustomView.Row>
        {/* <CustomRadioButtonGroup
          menus={values.radioButtonItems.rbiIsBlock}
          selected={selectedFilters?.isBlock}
          onClick={(selected: iItem | null) => setSelectedFilters({...selectedFilters, isBlock: selected})}
        /> */}
        <div className="filter-footer">
          <CustomButton2
            title={t("reset")}
            onClick={resetFilter}
            type="primary"
          />
        </div>
      </CustomDropdownFilter>
    </div>
  );
};

export default FilterAgent;
